import React from "react";
import {Typography} from "@mui/material";
import {Link as RouterLink, useLocation, useNavigate} from "react-router-dom";
import CheckMailInbox from '../../CheckMailInbox/CheckMailInbox';
import classes from "./LoginTemplate.module.scss"
import FormLogin from "../../__organisms/FormLogin/FormLogin";

const LoginTemplate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const registration = location.state as {registrationEmailSent?: boolean; email?: string} | null;
  if (registration?.registrationEmailSent) {
    return <CheckMailInbox email={registration.email} onContinue={() => navigate('/login', {replace: true, state: null})}/>;
  }
  return (
    <div className={classes['login-page']}>
      <div className={classes['login-page__inner']}>
        <div className={classes['login-page__hero']}>
          <img className={classes['login-page__logo']} src={`/plan-m-light.png`} alt="PayMe"/>
          <Typography variant="h4" component="h1" className={classes['login-page__title']}>
            PayMe
          </Typography>
          <Typography variant="body2" className={classes['login-page__subtitle']}>
            Scan receipts. Split bills. Simple.
          </Typography>
        </div>
        <div className={classes['login-page__panel']}>
          <Typography variant="h6" component="h2" className={classes['login-page__heading']}>
            Sign in to your account
          </Typography>
          <FormLogin/>
          <p className={classes['login-page__switch']}>
            No account?{' '}
            <RouterLink to="/register" className={classes['login-page__link']}>
              Create one free
            </RouterLink>
          </p>
        </div>
      </div>
    </div>)
}

export default LoginTemplate;
